import { DocumentType } from 'shared/domains/apollo/generated/types';
import { PreviewContext } from './context';
import { isDocxDocument } from '../../utils/isDocxDocument';
import { isPdfDocument } from '../../utils/isPdfDocument';
import { isSentForSigning } from '../../utils/isSentForSigning';
function PreviewProvider(props) {
    const { document, children, company } = props;
    const { type } = document;
    const sentForSigning = isSentForSigning(document);
    const isFreeText = !sentForSigning && type === DocumentType.Freetext;
    const isComposed = !sentForSigning && type === DocumentType.Composed;
    const isUploaded = !sentForSigning && type === DocumentType.Uploaded;
    const isUnknown = type === DocumentType.Unknown;
    const isDocx = !sentForSigning && isDocxDocument(document);
    const isPdf = sentForSigning || isPdfDocument(document);
    const isNotSupported = isUnknown || (isUploaded && !isPdf && !isDocx);
    const isRtcAvailable = type === DocumentType.Composed || type === DocumentType.Freetext;
    const values = {
        id: document.id,
        name: document.name,
        company,
        isFreeText,
        isComposed,
        isDocx,
        isPdf,
        isNotSupported,
        isRtcAvailable,
    };
    return <PreviewContext.Provider value={values}>{children}</PreviewContext.Provider>;
}
export { PreviewProvider };
